import { groupByDay } from "@nova/format"
import { Comment } from "@nova/schemas"

export type MapComment = Comment<"map-pin" | "map-comment">

export const groupCommentsByDay = (comments: MapComment[]) =>
    groupByDay(comments, (comment) => comment.createdAt)
